import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '../../../core/login/services/auth.store';
import { LoggerService } from '../../../core/logging/logger.service';

@Component({
  selector: 'app-auth-callback',
  imports: [],
  templateUrl: './auth-callback.html',
  styleUrls: ['./auth-callback.css'],
})

export class AuthCallbackComponent implements OnInit {

  private readonly router = inject(Router);
  private readonly authStore = inject(AuthStore);
  private readonly logger = inject(LoggerService);

  /**
   * Called when the component is initialized.
   * It fetches the authentication session and navigates to the appropriate route based on the presence of tokens.
   */
  async ngOnInit() {
    this.logger.info('AuthCallbackComponent', 'Auth callback initiated');
    
    // This is needed to load the user authentication session before navigating
    try {
      this.logger.debug('AuthCallbackComponent', 'Loading user authentication session');
      await this.authStore.loadUser();
      this.logger.debug('AuthCallbackComponent', 'User authentication session loaded', { authenticated: this.authStore.isAuthenticated() });
      
      if (this.authStore.isAuthenticated()) {
        this.logger.info('AuthCallbackComponent', 'User authenticated, navigating to protected route');
        this.router.navigate(['/protected']);
      } else {
        this.logger.warn('AuthCallbackComponent', 'User not authenticated after callback, redirecting to public');
        this.router.navigate(['/public']);
      }
    } catch (err) {
      this.logger.error('AuthCallbackComponent', 'Error loading user authentication session', err);
      this.router.navigate(['/public']);
    }
  }
}

